<!-- Hero Section -->
<section class="max-w-7xl mx-auto px-8 py-16">
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-24 items-start">
        <!-- Left Column: Contact Details & Map -->
        <div class="space-y-12">
            <div class="space-y-6">
                <h1 class="text-5xl font-extrabold tracking-tight text-on-background leading-tight">
                    Get in touch with our experts.
                </h1>
                <p class="text-lg text-on-surface-variant max-w-md">
                    We're here to help you architect your business success. Reach out for a custom demo or consultation.
                </p>
            </div>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
                <div class="p-6 rounded-xl bg-surface-container-low">
                    <span class="material-symbols-outlined text-primary-container mb-4 text-3xl">location_on</span>
                    <h3 class="font-bold text-lg mb-2">Global Headquarters</h3>
                    <p class="text-on-surface-variant text-sm leading-relaxed">
                        Alexandria, Egypt.
                    </p>
                </div>
                <div class="p-6 rounded-xl bg-surface-container-low">
                    <span class="material-symbols-outlined text-primary-container mb-4 text-3xl">call</span>
                    <h3 class="font-bold text-lg mb-2">Direct Line</h3>
                    <p class="text-on-surface-variant text-sm leading-relaxed">
                        <a href="tel:+201062017149" class="text-primary hover:underline">+201062017149</a><br />
                        Sunday - Thursday, 9:00 AM - 6:00 PM.
                    </p>
                </div>
                <div class="p-6 rounded-xl bg-surface-container-low">
                    <span class="material-symbols-outlined text-primary-container mb-4 text-3xl">mail</span>
                    <h3 class="font-bold text-lg mb-2">Email Support</h3>
                    <p class="text-on-surface-variant text-sm leading-relaxed">
                        <a href="mailto:support@zad-erp.net"
                            class="text-primary hover:underline">support&#64;zad-erp.net</a><br />
                        <a href="mailto:sales@zad-erp.net" class="text-primary hover:underline">sales&#64;zad-erp.net</a>
                    </p>
                </div>
                <div class="p-6 rounded-xl bg-surface-container-low">
                    <span class="material-symbols-outlined text-primary-container mb-4 text-3xl">contact_mail</span>
                    <h3 class="font-bold text-lg mb-2">Contact</h3>
                    <p class="text-on-surface-variant text-sm leading-relaxed">
                        <a href="mailto:contact@zad-erp.net" class="text-primary hover:underline">contact&#64;zad-erp.net</a><br />
                        <a href="tel:+201062017149" class="text-primary hover:underline">+201062017149</a>
                    </p>
                </div>
            </div>
            <!-- Styled Map Embed -->
            <div
                class="relative w-full h-[350px] rounded-2xl overflow-hidden shadow-xl shadow-slate-200/50 bg-surface-container">
                <img alt="ZAD ERP Global Headquarters"
                    class="w-full h-full object-cover grayscale brightness-90 contrast-125"
                    src="https://lh3.googleusercontent.com/aida-public/AB6AXuBqbEW_vXD9O7ARM1vQ_EboL4yvQF5YAVOM0q1DIsAIRqPEAzj3dOKZ4IlCjHcs1zk-iITCNaVSTt9HHD6CM5xn25EM0gsv5ilMM750uB8oTAKG4VMI8Dmh3t6zTjg_OU7jP-Xku4RV0XkojMlL0zuFsJvLtY2vljizMI0SIcePME6VaTXM0ypP6LiMCdZaeAgn8WsnW72LcvGtXzsx51gqhwYIAAR99kP_mG9TmK0xUDbrOw9_JsaFRzUvlF_nlGwjhTa2_IxM2ls" />
                <div class="absolute inset-0 bg-primary/10 pointer-events-none"></div>
                <div
                    class="absolute bottom-6 start-6 bg-surface-container-lowest p-4 rounded-xl shadow-lg border-s-4 border-primary-container">
                    <p class="font-bold text-sm">Global HQ</p>
                    <p class="text-xs text-on-surface-variant">Alexandria, Egypt</p>
                </div>
            </div>
        </div>
        <!-- Right Column: Elevated Form Card -->
        <div class="lg:sticky lg:top-32">
            <div
                class="bg-surface-container-lowest p-10 rounded-[2rem] shadow-2xl shadow-slate-200/60 relative overflow-hidden">
                <div class="absolute top-0 end-0 w-32 h-32 bg-primary/5 rounded-full -me-16 -mt-16"></div>
                <div class="relative">
                    <h2 class="text-3xl font-extrabold mb-2 font-['Manrope']">Send a Message</h2>
                    <p class="text-on-surface-variant mb-8 font-medium"><br /></p>
                    <form class="space-y-6" (submit)="onSubmit($event)">
                         <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <div class="space-y-2">
                                <label
                                    class="text-xs font-bold text-on-surface-variant uppercase tracking-wider px-1">Full Name *</label>
                                <input
                                    class="w-full bg-surface-container-low border-none rounded-xl px-4 py-3 focus:ring-2 focus:ring-primary-container/40 text-on-surface placeholder:text-outline-variant transition-all"
                                    placeholder="John Architect" required name="fullName" [(ngModel)]="fullName" type="text" />
                            </div>
                            <div class="space-y-2">
                                <label
                                    class="text-xs font-bold text-on-surface-variant uppercase tracking-wider px-1">Email Address *</label>
                                <input
                                    class="w-full bg-surface-container-low border-none rounded-xl px-4 py-3 focus:ring-2 focus:ring-primary-container/40 text-on-surface placeholder:text-outline-variant transition-all"
                                    placeholder="john@firm.com" required name="email" [(ngModel)]="email" type="email" />
                            </div>
                        </div>
                        <div class="space-y-2">
                            <label class="text-xs font-bold text-on-surface-variant uppercase tracking-wider px-1">Mobile Number *</label>
                            <div class="flex gap-2 relative">
                                <div (click)="toggleCountryDropdown()" class="flex items-center gap-2 px-4 py-3 bg-surface-container-low rounded-xl cursor-pointer hover:bg-surface-container-high transition-colors">
                                    <span class="text-sm font-medium text-on-surface">{{selectedCountry.code}}</span>
                                    <span class="material-symbols-outlined text-sm text-on-surface-variant">expand_more</span>
                                </div>
                                
                                <!-- Country Dropdown -->
                                <div *ngIf="isCountryDropdownOpen" class="absolute top-[110%] start-0 w-[120px] bg-surface-container-lowest rounded-xl shadow-xl shadow-slate-200/50 border border-outline-variant/15 z-50 overflow-hidden max-h-[200px] overflow-y-auto">
                                    <div *ngFor="let country of countryCodes" (click)="selectCountry(country)" class="px-4 py-3 hover:bg-surface-container-high cursor-pointer flex justify-between items-center transition-colors">
                                        <span class="text-sm font-bold text-on-surface">{{country.code}}</span>
                                        <span class="text-xs font-medium text-on-surface-variant">{{country.country}}</span>
                                    </div>
                                </div>

                                <input
                                    class="flex-1 w-full bg-surface-container-low border-none rounded-xl px-4 py-3 focus:ring-2 focus:ring-primary-container/40 text-on-surface placeholder:text-outline-variant transition-all"
                                    [placeholder]="selectedCountry.placeholder" type="tel" required name="phone" [(ngModel)]="phone" />
                            </div>
                        </div>
                        <div class="space-y-2">
                            <label class="text-xs font-bold text-on-surface-variant uppercase tracking-wider px-1">Message *</label>
                            <textarea
                                class="w-full bg-surface-container-low border-none rounded-xl px-4 py-3 focus:ring-2 focus:ring-primary-container/40 text-on-surface placeholder:text-outline-variant transition-all"
                                placeholder="How can we help your business scale?" required name="message" [(ngModel)]="message"
                                rows="4"></textarea>
                        </div>
                        <div class="pt-4">
                            <button
                                class="w-full bg-primary-container text-white py-4 rounded-xl font-bold text-lg hover:opacity-90 active:scale-[0.98] transition-all shadow-xl shadow-blue-500/30 flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
                                type="submit" [disabled]="!fullName || !email || !phone || !message">Submit Request<span
                                    class="material-symbols-outlined">arrow_forward</span></button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</section>